var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import { statusMapper } from '../../../../classes/definitions/order/order';
import ApiRequests from '../../../../classes/http/ApiRequests';
import HttpRequests from '../../../../classes/http/HttpRequests';
import AppRoutes from '../../../../config/appRoutes';
import Address from './Address';
import CartItem from './CartItem';
import CartTotals from './CartTotals';
import InvoiceData from './InvoiceData';
var ViewOrder = /** @class */ (function (_super) {
    __extends(ViewOrder, _super);
    function ViewOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            line_items: [],
            line_samples: [],
            coupon: [],
            cart: null,
            delivery_method: null,
            payment_method: null,
            invoice: null,
            address: null,
            packing_detail_id: null,
            packing_detail: null,
            number: null,
            bol_number: null,
            refresh_message: null,
            erp_document_status: null,
            erp_status: null,
            buttonDisabled: false,
            assignedOperator: null,
            currency: null,
        };
        _this.refreshOrderStatus = function (id) {
            _this.api.refreshOrderStatus(id)
                .then(function (response) {
                var updatedErpDocumentStatus = statusMapper('erp_document_state', response.data.erp_document_state);
                _this.setState({
                    refresh_message: response.data.message,
                    erp_document_status: updatedErpDocumentStatus,
                    erp_status: response.data.erp_status
                });
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message,
                });
            });
        };
        _this.resenderErpStatus = function (id) {
            _this.setState({ buttonDisabled: true });
            _this.api.resenderErpStatus(id)
                .then(function (response) {
                var updatedErpStatus = statusMapper('erp_status', response.data.erp_status);
                ;
                var updatedErpStatusMessage = response.data.message;
                _this.setState({
                    buttonDisabled: false,
                    erp_status: updatedErpStatus,
                    refresh_message: updatedErpStatusMessage
                });
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message,
                    erp_status: err.response.data.erp_status
                });
            });
        };
        _this.getOrder = function (id) {
            _this.api.getOrder(id)
                .then(function (response) {
                var data = _.get(response, 'data', null);
                var updatedErpDocumentStatus = statusMapper('erp_document_state', response.data.erp_document_state);
                var updatedErpStatus = statusMapper('erp_status', response.data.erp_status);
                _this.setState({
                    line_items: _.get(data, 'line_items', []),
                    line_samples: _.get(data, 'line_samples', []),
                    cart: _.get(data, 'cart', null),
                    delivery_method: _.get(data, 'delivery_method', null),
                    payment_method: _.get(data, 'payment_method', null),
                    invoice: _.get(data, 'invoice', null),
                    address: _.get(data, 'address', null),
                    packing_detail_id: _.get(data, 'packing_detail_id', null),
                    packing_detail: _.get(data, 'packing_detail', null),
                    number: _.get(data, 'number', null),
                    bol_number: _.get(data, 'bol_number', null),
                    coupon: _.get(data, 'coupon', []),
                    erp_document_status: updatedErpDocumentStatus,
                    erp_status: updatedErpStatus,
                    assignedOperator: _.get(data, "assigned_operator", null),
                    currency: _.get(data, 'currency', null),
                });
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на поръчката';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toOrdersPage = function () {
            _this.props.history.push(AppRoutes.orders.path);
        };
        _this.generateBol = function () {
            _this.api.generateBol(_this.editId)
                .then(function (response) {
                _this.setState({ bol_number: _.get(response, 'data.bol_number', '') });
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при генериране на бол';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setGift = function (item, index) {
            var gift = item.attributes.variant.attributes.gift ? item.attributes.variant.attributes.gift : null;
            if (gift !== null) {
                return React.createElement(CartItem, { key: index, item: gift, currencyLabel: "bgn" });
            }
            else {
                return null;
            }
        };
        _this.assignOperator = function (id) {
            _this.api.assignOrderToOperator(id)
                .then(function (response) {
                var operator = _.get(response, 'data.assigned_operator', null);
                _this.setState({
                    assignedOperator: operator,
                });
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при вземане на поръчка.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
            return 0;
        };
        return _this;
    }
    ViewOrder.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.num', '-1');
        if (this.editId !== '-1') {
            this.getOrder(this.editId);
        }
    };
    ViewOrder.prototype.render = function () {
        var _this = this;
        var _a = this.state, line_items = _a.line_items, line_samples = _a.line_samples, invoice = _a.invoice, cart = _a.cart, delivery_method = _a.delivery_method, payment_method = _a.payment_method, number = _a.number, bol_number = _a.bol_number, coupon = _a.coupon, address = _a.address, packing_detail = _a.packing_detail, currency = _a.currency;
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toOrdersPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041D\u0430\u0437\u0430\u0434"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            React.createElement("div", { className: "container-fluid", style: { borderBottom: '1px solid #ccc' } },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-4" },
                        bol_number ? React.createElement("p", null,
                            "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u043D\u0438\u0446\u0430: ",
                            React.createElement("strong", null, bol_number)) :
                            React.createElement("button", { className: "btn btn-sm btn-primary", style: { marginBottom: 20 }, onClick: this.generateBol, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u0439 \u0442\u043E\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u043D\u0438\u0446\u0430"),
                        React.createElement("div", null,
                            React.createElement("button", { className: "btn btn-sm btn-primary", style: { marginBottom: 20 }, onClick: function () { return _this.refreshOrderStatus(number); }, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041E\u0431\u043D\u043E\u0432\u0438 \u0441\u0442\u0430\u0442\u0443\u0441")),
                        React.createElement("div", null,
                            !this.state.assignedOperator && (React.createElement("button", { className: "btn btn-sm btn-primary", style: { marginBottom: 20 }, onClick: function () { return _this.assignOperator(number); }, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0417\u0430\u043F\u043E\u0447\u043D\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430")),
                            this.state.assignedOperator && (React.createElement("p", { style: { marginBottom: 20 } }, this.state.assignedOperator))),
                        React.createElement("div", null,
                            React.createElement("button", { className: "btn btn-sm btn-primary", disabled: this.state.buttonDisabled, style: { marginBottom: 20 }, onClick: function () {
                                    _this.state.erp_status === 'erp_error' || _this.state.erp_status === 'Грешка' ? _this.resenderErpStatus(number) : console.log('Обновяването е възможно, само ако статуса на поръчката е erp_error');
                                }, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u0432 ERP")),
                        React.createElement("div", null,
                            React.createElement("p", null, this.state.refresh_message)),
                        React.createElement("p", null,
                            "\u041D\u043E\u043C\u0435\u0440: ",
                            React.createElement("strong", null, number)),
                        React.createElement("p", null,
                            "\u041C\u0435\u0442\u043E\u0434 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430: ",
                            React.createElement("strong", null, _.get(delivery_method, 'attributes.name', ''))),
                        React.createElement("p", null,
                            "\u041C\u0435\u0442\u043E\u0434 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435: ",
                            React.createElement("strong", null, _.get(payment_method, 'attributes.name', ''))),
                        React.createElement("p", null,
                            "\u0421\u0442\u0430\u0442\u0443\u0441 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430: ",
                            React.createElement("strong", null, this.state.erp_document_status)),
                        React.createElement("p", null,
                            "\u0421\u0442\u0430\u0442\u0443\u0441 \u0432 ERP: ",
                            React.createElement("strong", null, this.state.erp_status)),
                        React.createElement("p", null,
                            "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434:",
                            React.createElement("strong", null,
                                _.get(this.state.coupon, 'attributes.code', 'Няма'),
                                " (",
                                _.get(this.state.coupon, 'attributes.discount_value', ''),
                                _.get(this.state.coupon, 'attributes.discount_type', '') === 'amount' ? ' лв.' : '',
                                _.get(this.state.coupon, 'attributes.discount_type', '') === 'percentage' ? ' %' : '',
                                ")")),
                        React.createElement("p", null,
                            "\u0412\u0430\u043B\u0443\u0442\u0430: ",
                            React.createElement("strong", null, this.state.currency === "eur" ? " €" : " лв."))),
                    React.createElement("div", { className: "col-md-4" }, invoice ? React.createElement(InvoiceData, { data: invoice }) : null),
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement(Address, { data: address, type: _.get(delivery_method, 'attributes.delivery_type', '') })))),
            packing_detail ? React.createElement("div", { className: "container-fluid", style: { borderBottom: '1px solid #ccc' } },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement("h5", { style: { margin: '20px 0' } }, "\u041E\u043F\u0430\u043A\u043E\u0432\u043A\u0430 \u0438 \u043A\u0430\u0440\u0442\u0438\u0447\u043A\u0430"),
                        React.createElement("p", null,
                            "\u0418\u043C\u0435: ",
                            React.createElement("strong", null, _.get(packing_detail, 'attributes.name', 'Няма'))),
                        React.createElement("p", null,
                            "\u041F\u043E\u0437\u0434\u0440\u0430\u0432: ",
                            React.createElement("strong", null, _.get(packing_detail, 'attributes.description', 'Няма')))))) : null,
            line_items.map(function (item, index) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(CartItem, { key: index, item: item, currencyLabel: _this.state.currency }),
                    _this.setGift(item, index)));
            }),
            line_samples.map(function (item, index) {
                var sample = _.get(item, 'attributes.sample', null);
                return React.createElement(CartItem, { key: index, isSample: true, item: sample, currencyLabel: _this.state.currency });
            }),
            React.createElement(CartTotals, { totals: cart, currencyLabel: this.state.currency }),
            actionBtns));
    };
    return ViewOrder;
}(React.Component));
// @ts-ignore
export default withRouter(ViewOrder);



//////////////////
// WEBPACK FOOTER
// ./src/components/Orders/OrdersList/OrderDetails/OrderDetails.tsx
// module id = 387
// module chunks = 0